import { useNavigate } from "react-router-dom";
import { FaTimes, FaSearch, FaUserPlus, FaUser, FaIdCard, FaPlus, FaCheck } from "react-icons/fa";
import CommonModal from "Components/CommonModal";
import { useState } from "react";
import { commonModalSetting } from "JS/common";
import { getCouponSearchMember, issuedCoupons } from "JS/API";

// 디자인 시스템 임포트
import { designTokens, commonStyles, badgeStyles } from "utils/designSystem";
import { detailModalStyles } from "utils/modalDesignSystem";

const SearchUserModal = ({ setIsOpenSearchModal, detailData, fetchDetail }) => {
  const navigate = useNavigate();
  const [alert] = useState("");
  const [alertBox, setAlertBox] = useState({ mode: "", context: "", bool: false });

  const [searchName, setSearchName] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  // 스타일 정의
  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001,
      padding: designTokens.spacing.xxl
    },
    container: {
      backgroundColor: designTokens.colors.surface,
      borderRadius: designTokens.borderRadius.xl,
      boxShadow: designTokens.shadows.lg,
      width: '100%',
      maxWidth: '800px',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    header: detailModalStyles.header,
    title: {
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.md,
      fontSize: '18px',
      fontWeight: '600',
      color: designTokens.colors.text.primary,
      margin: 0
    },
    closeButton: detailModalStyles.closeButton,
    content: {
      flex: 1,
      overflow: 'auto',
      padding: designTokens.spacing.xxl,
      maxHeight: 'calc(90vh - 140px)'
    },
    searchSection: {
      ...commonStyles.card,
      padding: designTokens.spacing.xl,
      marginBottom: designTokens.spacing.xl,
      backgroundColor: designTokens.colors.background
    },
    searchForm: {
      display: 'flex',
      gap: designTokens.spacing.md,
      alignItems: 'center'
    },
    searchLabel: {
      fontSize: '14px',
      fontWeight: '600',
      color: designTokens.colors.text.primary,
      minWidth: '50px'
    },
    searchInput: {
      ...commonStyles.input,
      flex: 1
    },
    searchButton: {
      ...commonStyles.buttonBase,
      backgroundColor: designTokens.colors.primary,
      color: designTokens.colors.surface,
      padding: `${designTokens.spacing.md} ${designTokens.spacing.xl}`,
      fontSize: '14px',
      fontWeight: '600'
    },
    resultsSection: {
      marginBottom: designTokens.spacing.xl,
      maxHeight: '400px',
      display: 'flex',
      flexDirection: 'column'
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: designTokens.colors.text.primary,
      marginBottom: designTokens.spacing.lg,
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.sm
    },
    tableContainer: {
      ...commonStyles.tableContainer,
      marginBottom: 0,
      maxHeight: '300px',
      overflow: 'auto',
      flex: 1
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      tableLayout: 'fixed'
    },
    th: {
      ...commonStyles.th,
      textAlign: 'center'
    },
    td: {
      ...commonStyles.td,
      textAlign: 'center',
      verticalAlign: 'middle',
      wordBreak: 'break-word',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    selectButton: {
      ...commonStyles.buttonBase,
      backgroundColor: designTokens.colors.success,
      color: designTokens.colors.surface,
      padding: `${designTokens.spacing.xs} ${designTokens.spacing.sm}`,
      fontSize: '12px',
      minWidth: '60px',
      whiteSpace: 'nowrap'
    },
    selectedSection: {
      marginBottom: designTokens.spacing.xl
    },
    selectedList: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: designTokens.spacing.md,
      minHeight: '60px',
      padding: designTokens.spacing.lg,
      backgroundColor: designTokens.colors.background,
      borderRadius: designTokens.borderRadius.lg,
      border: `1px dashed ${designTokens.colors.border}`
    },
    selectedItem: {
      ...badgeStyles.base,
      backgroundColor: designTokens.colors.primary,
      color: designTokens.colors.surface,
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.sm,
      padding: `${designTokens.spacing.sm} ${designTokens.spacing.md}`,
      fontSize: '13px',
      height: 'fit-content'
    },
    removeButton: {
      background: 'none',
      border: 'none',
      color: designTokens.colors.surface,
      cursor: 'pointer',
      padding: '2px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '16px',
      height: '16px',
      fontSize: '10px',
      transition: 'background-color 0.2s ease'
    },
    emptySelected: {
      color: designTokens.colors.text.muted,
      fontStyle: 'italic',
      textAlign: 'center',
      padding: designTokens.spacing.lg,
      width: '100%'
    },
    actionButtons: detailModalStyles.actionButtons,
    primaryButton: detailModalStyles.primaryButton,
    secondaryButton: detailModalStyles.secondaryButton,
    noResults: {
      textAlign: 'center',
      padding: `${designTokens.spacing.xxl} ${designTokens.spacing.lg}`,
      color: designTokens.colors.text.muted,
      fontStyle: 'italic'
    }
  };

  // 원본 기능 그대로 유지
  const handleSearch = async () => {
    if (!searchName.trim()) return;
    const res = await getCouponSearchMember(searchName);
    if (res?.status === 200 && res) {
      setSearchResult(res.data);
    } else {
      setSearchResult([]);
      commonModalSetting(setAlertBox, true, "alert", "검색 결과가 없습니다.");
    }
  };

  const handleSelect = (user) => {
    console.log('선택 버튼 클릭됨:', user);
    console.log('현재 선택된 사용자들:', selectedUsers);
    
    if (!selectedUsers.some((u) => u.user_id === user.user_id)) {
      const newSelected = [...selectedUsers, user];
      setSelectedUsers(newSelected);
      console.log('새로 선택된 사용자들:', newSelected);
    } else {
      console.log('이미 선택된 사용자입니다:', user.user_id);
    }
  };

  const handleRemoveSelected = (id) => {
    setSelectedUsers(selectedUsers.filter((u) => u.user_id !== id));
  };

  const handleIssue = async () => {
    if (selectedUsers.length === 0) {
      commonModalSetting(setAlertBox, true, "alert", "선택된 회원이 없습니다.");
      return;
    }

    const payload = {
      id: detailData.id,
      coupon_code: detailData.coupon_code,
      user_pk: selectedUsers.map((u) => u.user_pk),
    };

    const res = await issuedCoupons(payload);

    if (res?.status === 200) {
      commonModalSetting(setAlertBox, true, "alert", "선택 발급이 완료되었습니다.");
      setIsOpenSearchModal(false);
      fetchDetail();
    } else {
      commonModalSetting(setAlertBox, true, "alert", "선택 발급에 실패했습니다.");
    }
  };

  return (
    <>
      <div style={modalStyles.overlay} >
        <div style={modalStyles.container} onClick={(e) => e.stopPropagation()}>
          {/* 헤더 */}
          <div style={modalStyles.header}>
            <h3 style={modalStyles.title}>
              <FaUserPlus />
              선택 발급 (회원 이름 검색)
            </h3>
            <button
              style={modalStyles.closeButton}
              onClick={() => setIsOpenSearchModal(false)}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = designTokens.colors.background;
                e.target.style.color = designTokens.colors.text.primary;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = designTokens.colors.text.tertiary;
              }}
            >
              <FaTimes size={16} />
            </button>
          </div>

          {/* 컨텐츠 */}
          <div style={modalStyles.content}>
            {/* 검색 섹션 */}
            <div style={modalStyles.searchSection}>
              <div style={modalStyles.searchForm}>
                <label style={modalStyles.searchLabel}>이름:</label>
                <input
                  style={modalStyles.searchInput}
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSearch();
                  }}
                  placeholder="회원 이름을 입력하세요"
                />
                <button
                  style={modalStyles.searchButton}
                  onClick={handleSearch}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = designTokens.colors.primaryHover || '#2563eb';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = designTokens.colors.primary;
                  }}
                >
                  <FaSearch size={12} />
                  검색
                </button>
              </div>
            </div>

            {/* 검색 결과 */}
            <div style={modalStyles.resultsSection}>
              <h4 style={modalStyles.sectionTitle}>
                <FaSearch size={14} />
                검색 결과 ({searchResult.length})
              </h4>
              
              {searchResult.length > 0 ? (
                <div style={modalStyles.tableContainer}>
                  <div style={{ 
                    maxHeight: '300px', 
                    overflow: 'auto',
                    border: `1px solid ${designTokens.colors.border}`,
                    borderRadius: designTokens.borderRadius.lg 
                  }}>
                    <table style={modalStyles.table}>
                      <colgroup>
                        <col width="25%" />
                        <col width="50%" />
                        <col width="25%" />
                      </colgroup>
                      <thead style={{ 
                        position: 'sticky', 
                        top: 0, 
                        backgroundColor: designTokens.colors.background,
                        zIndex: 1 
                      }}>
                        <tr>
                          <th style={modalStyles.th}>이름</th>
                          <th style={modalStyles.th}>아이디</th>
                          <th style={modalStyles.th}>선택</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchResult.map((user, idx) => {
                          const isAlreadySelected = selectedUsers.some((u) => u.user_id === user.user_id);
                          return (
                            <tr key={idx}>
                              <td style={{...modalStyles.td, whiteSpace: 'normal'}}>
                                <div style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  justifyContent: 'center', 
                                  gap: designTokens.spacing.xs,
                                  wordBreak: 'break-word'
                                }}>
                                  <FaUser size={12} style={{ color: designTokens.colors.text.tertiary, flexShrink: 0 }} />
                                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {user.user_name}
                                  </span>
                                </div>
                              </td>
                              <td style={{...modalStyles.td, whiteSpace: 'normal'}}>
                                <div style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  justifyContent: 'center', 
                                  gap: designTokens.spacing.xs,
                                  wordBreak: 'break-word'
                                }}>
                                  <FaIdCard size={12} style={{ color: designTokens.colors.text.tertiary, flexShrink: 0 }} />
                                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {user.user_id}
                                  </span>
                                </div>
                              </td>
                              <td style={modalStyles.td}>
                                {isAlreadySelected ? (
                                  <span style={{
                                    ...modalStyles.selectButton,
                                    backgroundColor: designTokens.colors.secondary,
                                    opacity: 0.6,
                                    cursor: 'not-allowed'
                                  }}>
                                    <FaCheck size={10} />
                                    선택됨
                                  </span>
                                ) : (
                                  <button
                                    style={{
                                      ...modalStyles.selectButton,
                                      cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                      console.log('버튼 클릭 이벤트 발생');
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleSelect(user);
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor = designTokens.colors.successHover || '#047857';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor = designTokens.colors.success;
                                    }}
                                  >
                                    <FaPlus size={10} />
                                    선택
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div style={modalStyles.noResults}>
                  검색을 통해 회원을 찾아보세요.
                </div>
              )}
            </div>

            {/* 선택된 회원 */}
            <div style={modalStyles.selectedSection}>
              <h4 style={modalStyles.sectionTitle}>
                <FaCheck size={14} />
                선택된 회원 ({selectedUsers.length})
              </h4>
              
              <div style={modalStyles.selectedList}>
                {selectedUsers.length === 0 ? (
                  <div style={modalStyles.emptySelected}>
                    선택된 회원이 없습니다.
                  </div>
                ) : (
                  selectedUsers.map((user, idx) => (
                    <div key={idx} style={modalStyles.selectedItem}>
                      <FaUser size={10} />
                      {user.user_name} ({user.user_id})
                      <button
                        style={modalStyles.removeButton}
                        onClick={() => handleRemoveSelected(user.user_id)}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* 액션 버튼 */}
          <div style={modalStyles.actionButtons}>
            <button
              style={modalStyles.primaryButton}
              onClick={handleIssue}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = designTokens.colors.primaryHover || '#2563eb';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = designTokens.colors.primary;
              }}
            >
              <FaPlus size={12} />
              추가
            </button>
            <button
              style={modalStyles.secondaryButton}
              onClick={() => setIsOpenSearchModal(false)}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = designTokens.colors.background;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = designTokens.colors.surface;
              }}
            >
              취소
            </button>
          </div>
        </div>
      </div>

      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
          }}
        />
      )}
    </>
  );
};

export default SearchUserModal;